import * as yup from 'yup';
import { site } from '@panel/commons/helpers';

const step1Module2Schema = yup.object().shape({
  addressVal: yup
    .string()
    .when(
      ['$disableChanges', '$hasSearchWithCep', '$validateCep'],
      (disableChanges, hasSearchWithCep, validateCep, schema) => {
        // Solo evaluar addressVal si hasSearchWithCep es true O validateCep es false
        const shouldValidate = hasSearchWithCep || !validateCep;

        if (!disableChanges && shouldValidate) {
          return schema.required();
        }
        return schema.notRequired();
      }
    ),
  cep: yup.string().when(['$validateCep', '$hasSearchWithCep'], (validateCep, hasSearchWithCep, schema) => {
    if (validateCep) {
      return schema.test('cep-validation', function(value) {
        // si no se hizo la busqueda con cep mostrar error especifico
        if (!hasSearchWithCep) {
          return this.createError({
            message: 'professionalPubli.location.cep.empty'
          });
        }
        // si se hizo la busqueda pero el campo esta vacio, requerir el campo
        if (!value || value.trim().length === 0) {
          return this.createError({
            message: 'professionalPubli.location.cep.invalid'
          });
        }
        return true;
      });
    }
    return schema.notRequired();
  }),
  addressComplement: yup
    .string()
    .max(40, 'publisher.step1.module2.complement.error')
    .notRequired(),
  provinceVal: yup.string().when('addressVal', {
    is: val => val && val.trim().length > 0,
    then: schema => schema.required(),
    otherwise: schema => schema.notRequired()
  }),
  cityVal: yup.string().when('addressVal', {
    is: val => val && val.trim().length > 0,
    then: schema => schema.required(),
    otherwise: schema => schema.notRequired()
  }),
  districtIsRequired: yup.string(),
  districtVal: yup.string().when('$validateDistrict', (validateDistrict, schema) => {
    return validateDistrict && site.id !== 'ZPAR' ? schema.trim().required() : schema.notRequired();
  }),
  subDistrictVal: yup.string().notRequired(),
  postalCode: yup
    .string()
    .notRequired()
    .max(100)
});

export { step1Module2Schema };
